import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { Icon } from '@mui/material';
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function ModalComponent({ open, onClose, item, handleRefresh, fromAdmin }) {
    const AppService = useAppServices();
    const [agency] = useAgencyInfo();
    const [waiting, setWaiting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        if (fromAdmin) {
            const catRecord = item?.superadmin_template_cats?.find(c => c.type === 'category');
            if (catRecord) {
                const cat = agency?.Categories?.find(c => c._id?.toString() === catRecord.item_id || c.id === catRecord.item_id);
                setSelectedCategory(cat || null);
            } else {
                setSelectedCategory(null);
            }
            return;
        }

        if (item?.category && Array.isArray(item.category)) {
            const existing = item.category.find(cat => cat.agency_id === agency._id);
            setSelectedCategory(existing || null);
        } else if (item?.category?.id) {
            const existing = agency?.Categories?.find(cat => cat.id === item.category.id);
            setSelectedCategory(existing ? { ...existing, agency_id: agency._id } : null);
        }
    }, [item?.category, item?.superadmin_template_cats, agency?.Categories, agency._id, fromAdmin]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setWaiting(true);

        if (fromAdmin) {
            const item_ids = selectedCategory
                ? [selectedCategory._id?.toString() || selectedCategory.id]
                : [];
            const { response } = await AppService.superadmin_template_categories.save({
                payload: { template_id: item._id, agency_id: agency._id, type: 'category', item_ids },
                toaster: true,
            });
            if (response) {
                handleRefresh();
                onClose();
            }
        } else {
            const categoryWithAgencyId = selectedCategory ? { ...selectedCategory, agency_id: agency._id } : null;
            let updatedCategories = [];
            if (item?.category && Array.isArray(item.category)) {
                updatedCategories = item.category.filter(cat => cat.agency_id !== agency._id);
                if (selectedCategory) updatedCategories.push(categoryWithAgencyId);
            } else {
                updatedCategories = selectedCategory ? [categoryWithAgencyId] : [];
            }
            const payload = { _id: item._id, category: updatedCategories };
            const { response } = await AppService.promptslabel.update({ payload, toaster: true });
            if (response) {
                handleRefresh();
                onClose();
            }
        }

        setWaiting(false);
    };

    return (
        <>
            {open && (
                <div className="modal-zz-confirm text-left">
                    <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <h2 className='text-black text-left font-14' style={{ fontWeight: "700", marginBottom: '10px' }}>
                            Edit Prompt Category
                        </h2>
                        <span className='crossison' onClick={onClose}>X</span>

                        <SoftBox component="form" onSubmit={handleSubmit}>
                            <label className="mb-1">Category</label>
                            <select
                                style={{ width: "100%", padding: "12px", borderRadius: "4px", border: "1px solid #ccc" }}
                                value={selectedCategory?.id || selectedCategory?._id || ''}
                                onChange={e => {
                                    const cat = agency?.Categories?.find(c => c.id === e.target.value || c._id?.toString() === e.target.value);
                                    setSelectedCategory(cat || null);
                                }}
                            >
                                <option value="">Select Category</option>
                                {agency?.Categories?.map((category) => (
                                    <option key={category.id || category._id} value={category.id || category._id}>
                                        {category.name}
                                    </option>
                                ))}
                            </select>

                            <SoftBox mt={2}>
                                <button className="savebtn-setting w-100" type="submit" disabled={waiting || !selectedCategory}>
                                    {waiting && (
                                        <div className="spinner" style={{ width: '16px', height: '16px', display: "inline-block", marginRight: "8px" }}></div>
                                    )}
                                    Edit Prompt Category
                                </button>
                            </SoftBox>
                        </SoftBox>
                    </div>
                </div>
            )}
        </>
    );
}

ModalComponent.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    handleRefresh: PropTypes.func.isRequired,
    fromAdmin: PropTypes.bool,
};

function AddCategoryPrompt({ item, handleRefresh, fromAdmin }) {
    const [openAddMember, setOpenAddMember] = useState(false);

    return (
        <>
            <span style={{ cursor: 'pointer' }} onClick={() => setOpenAddMember(true)}><Icon>edit</Icon></span>
            <ModalComponent
                open={openAddMember}
                onClose={() => setOpenAddMember(false)}
                item={item}
                handleRefresh={handleRefresh}
                fromAdmin={fromAdmin}
            />
        </>
    );
}

AddCategoryPrompt.propTypes = {
    item: PropTypes.object.isRequired,
    handleRefresh: PropTypes.func.isRequired,
    fromAdmin: PropTypes.bool,
};

export default AddCategoryPrompt;
